module.exports = __webpack_public_path__ + "img/BA8979_DDCBCA_9A4726_892407-256px.4a980524.png";